/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import {
  MidasAdminOrganizationPermissions,
  MidasEffectError,
  Organization,
  RulePriority,
} from '@midas/shared/common';
import { createAction, props } from '@ngrx/store';

export const getCurrentOrg = createAction(
  '[Current Org] Get Current Org',
  props<{ organizationName: string }>(),
);
export const getCurrentOrgSuccess = createAction(
  '[Current Org] Get Current Org Success',
  props<{ org: Organization }>(),
);
export const getCurrentOrgError = createAction(
  '[Current Org] Get Current Org Error',
  props<MidasEffectError>(),
);

export const setCurrentOrg = createAction(
  '[Current Org] Set Current Org',
  props<{ organizationName: string }>(),
);

export const unloadCurrentOrg = createAction('[Current Org] Unload Current Org');

export const updateCurrentOrg = createAction(
  '[Current Org] Update Current Org',
  props<{
    orgId: number;
    name: string;
    midasAdminOrganizationPermissions?: MidasAdminOrganizationPermissions;
    address?: string;
    city?: string;
    state?: string;
    zip?: number;
    cartAutoLogoutTime?: number;
    anytimeWasteNotificationTimePeriod?: number;
    anytimeTransportNotificationTimePeriod?: number;
    rxInterceptRuleNotificationTimePeriod?: number;
    rxInterceptPriorityToAssay?: RulePriority;
    enforceUniqueBagIdentifiers?: boolean;
    alternateBinsOnORWaste?: boolean;
    patientRetentionLimit?: number;
    orderRetentionLimit?: number;
    enforceBinExpiry?: boolean;
    binExpiryDays?: number;
    showTestUserTransactions?: boolean;
    calcCopyPaste?: boolean;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    accountNumber: string;
    customDomain?: string;
  }>(),
);
export const updateCurrentOrgSuccess = createAction(
  '[Current Org] Update Current Org Success',
  props<{ org: Organization }>(),
);
export const updateCurrentOrgError = createAction(
  '[Current Org] Update Current Org Error',
  props<MidasEffectError>(),
);

export const updateCurrentOrgCollectionBaseline = createAction(
  '[Current Org] Update Current Org Collection Baseline',
  props<{
    baselineScheduleI: number;
    baselineScheduleII: number;
    baselineScheduleIII: number;
    baselineScheduleIV: number;
    baselineScheduleV: number;
    baselineNonControlled: number;
  }>(),
);
export const updateCurrentOrgCollectionBaselineSuccess = createAction(
  '[Current Org] Update Current Org Collection Baseline Success',
  props<{ org: Organization }>(),
);
export const updateCurrentOrgCollectionBaselineError = createAction(
  '[Current Org] Update Current Org Collection Baseline Error',
  props<MidasEffectError>(),
);

export const sendOrganizationUpdate = createAction(
  '[Current Org] Send Organization Update',
  props<{orgId: number}>(),
);
export const sendOrganizationUpdateSuccess = createAction(
  '[Current Org] Send Organization Update Success'
);
export const sendOrganizationUpdateError = createAction(
  '[Current Org] Send Organization Update Error',
  props<MidasEffectError>(),
);
